import { isBlockedSession } from '@/utils/promoterAccess';

/** The API decides; a session on a former promoter keeps the screen as its way back. */
export function canReachPromoterAccounts(user, isPromoterActive) {
  if (!user?.promoter_id) return false;

  return user.can_access_promoter_accesses === true
    || (isPromoterActive === false && !isBlockedSession(user));
}
